<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <el-card shadow="never" class="info-card">
      <div style="margin: 10px 0 0 8px">
        <FrameForm ref="frameForm" component-param="repair_item_edit" :parent-data="{id: repairItem.id}"></FrameForm>
      </div>
    </el-card>
  </div>
</template>

<script>

export default {
  name: "RepairItemUpdate",
  data() {
    return {
      sn: '',
      canWork: false,
      loading: false,
      repairItem: {},
      busItem: {},
    }
  },
  computed: {
    stationId() {
      if (this.componentParam && this.componentParam.length > 7) {
        return this.componentParam.substring(7);
      }
      return '';
    }
  },
  methods: {
    search() {
      this.reset()

      this.$refs.frameForm.formInfo = {} //清空作业表单内容
      this.$refs.frameForm.clearMessage()

      if (!this.sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('repairItemService.getBySnForUpdate', {
        sn: this.sn
      }, false).then(async data => {
        this.loading = false
        this.repairItem = data || {}
        await this.$refs.frameForm.initForm()
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })

    },
    reset() {
      this.repairItem = {}
      this.$refs.searchMessage.clear()

    }
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
}

.login-user {
  position: absolute;
  right: 10px;
}

.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

.table-header {
  background-color: #ECECECFF;
}
</style>